import PageHeader from "@/components/PageHeader";
import CTASection from "@/components/CTASection";
import { IT_COURSES } from "@/constants/site";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO, { breadcrumb } from "@/components/SEO";

export default function ITCourses() {
  return (
    <div>
      <SEO
        title="IT & Programming Courses — C, C++, Java, HTML, CSS, JavaScript | AM Group of Education"
        description="Beginner-friendly IT programming courses in C, C++, Java, HTML, CSS and JavaScript taught by working developers with hands-on projects."
        path="/it-courses"
        jsonLd={[
          breadcrumb([
            { name: "Home", path: "/" },
            { name: "IT Courses", path: "/it-courses" },
          ]),
        ]}
      />
      <PageHeader
        title="IT & Programming Courses"
        subtitle="From your first line of code to confidently building real projects — beginner-friendly tracks taught by working developers."
        crumb="IT Courses"
      />
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {IT_COURSES.map((c, i) => (
              <motion.div
                key={c.name}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -6 }}
                className="group relative flex flex-col h-full rounded-2xl border border-brand-line bg-brand-cream p-6 sm:p-7 shadow-[0_15px_40px_-25px_rgba(78,52,46,.35)] hover:shadow-[0_30px_70px_-30px_rgba(212,175,55,.45)] overflow-hidden"
                data-testid={`it-card-${c.name.replace(/\s+/g,'-').toLowerCase()}`}
              >
                <div className="pointer-events-none absolute -top-16 -right-16 w-40 h-40 rounded-full bg-brand-gold/10 blur-2xl group-hover:bg-brand-gold/25 transition-colors duration-500" />
                <div className="flex items-center justify-between">
                  <span className="w-14 h-14 rounded-2xl bg-brand-dark text-brand-gold grid place-items-center text-2xl shadow-lg">
                    <i className={`${c.brand ? "fa-brands" : "fa-solid"} fa-${c.icon}`} />
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.2em] font-semibold text-brand-primary bg-brand-gold/15 border border-brand-gold/40 rounded-full px-3 py-1">{c.level}</span>
                </div>
                <h3 className="mt-4 display-serif text-2xl font-bold text-brand-dark">{c.name}</h3>
                <p className="mt-2 text-sm text-brand-mute leading-relaxed flex-1">{c.desc}</p>
                <div className="mt-5 flex items-center gap-2 text-xs uppercase tracking-widest text-brand-primary font-semibold">
                  <i className="fa-regular fa-clock" /> {c.duration}
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  <Link to="/contact" data-testid={`it-learn-${c.name.replace(/\s+/g,'-').toLowerCase()}`} className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold border-2 border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white transition-all">
                    Learn More <i className="fa-solid fa-arrow-right text-[10px]" />
                  </Link>
                  <Link to="/contact" data-testid={`it-enroll-${c.name.replace(/\s+/g,'-').toLowerCase()}`} className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold bg-brand-primary text-white hover:bg-brand-gold hover:text-brand-dark transition-all shadow-md">
                    Enquire Now <i className="fa-solid fa-paper-plane text-[10px]" />
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
